import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { gql } from '@apollo/client';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
import { GetNavBarInfoQuery } from './codecs';
export var useGetNavBarInfo = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query GetNavBarInfo {\n      profile {\n        id\n        name\n        avatarUrl\n        currentPoints\n      }\n      unreadNotifications\n    }\n  "]))), GetNavBarInfoQuery);
export var useConsentStatus = makeDecodedQuery(gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    query ProfileConsentStatus {\n      consentStatus\n    }\n  "]))), t.type({
  consentStatus: t["boolean"]
}));